module.exports = __webpack_public_path__ + "static/media/outside_fence.1de47012.svg";